import PropTypes from "prop-types";

/**
 * One Settings section: a card with its title, a line on what it does to
 * the plan, and any error the server gave the section as a whole (a list
 * that's too long, two bands with one name). Labelled by its title, so it
 * is a region a screen reader (and a test) can jump to by name.
 */
function SettingsSection({ id, title, description, error, children }) {
  // `${id}-section` is the jump links' target (W20; `id` alone can be a
  // field's — the bodyweight input's): scroll-mt clears the sticky app
  // header when one lands here; the heading takes the focus.
  return (
    <section id={`${id}-section`} aria-labelledby={`${id}-title`} className="scroll-mt-24 rounded-lg border bg-card p-4 md:p-6">
      <h2 id={`${id}-title`} tabIndex={-1} className="m-0 font-display text-xl font-semibold outline-none">
        {title}
      </h2>
      {description && (
        <div className="mt-1 text-sm text-muted-foreground [&_p]:m-0 [&_p+p]:mt-1">
          {description}
        </div>
      )}
      {error && (
        <p id={`${id}-error`} className="mt-2 mb-0 text-sm text-destructive">
          {error}
        </p>
      )}
      <div className="mt-4 flex flex-col gap-4">{children}</div>
    </section>
  );
}

SettingsSection.propTypes = {
  id: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  description: PropTypes.node,
  error: PropTypes.string,
  children: PropTypes.node,
};

export default SettingsSection;
